// extracted by mini-css-extract-plugin
export default {"content":"Tabs_content__nDOis"};